const protected_app = {
    name: 'برنامه محافظت‌شده',
    title: 'ایجاد برنامه محافظت‌شده: افزودن احراز هویت با سادگی و سرعت بالا',
    fast_create: 'ایجاد سریع',
    modal_title: 'ایجاد برنامه محافظت‌شده',
    modal_subtitle: 'با چند کلیک محافظت امن و سریع را فعال کنید. احراز هویت را به‌راحتی به برنامه وب موجود خود اضافه کنید.',
    form: {
        url_field_label: 'URL مبدأ شما',
        url_field_placeholder: 'https://domain.com/',
        url_field_description: 'آدرس برنامه‌ای که نیاز به محافظت احراز هویت دارد را وارد کنید.',
        url_field_modification_notice: 'تغییرات URL مبدأ ممکن است تا ۱-۲ دقیقه طول بکشد تا در همه مکان‌های شبکه جهانی اعمال شود.',
        url_field_tooltip: "آدرس برنامه خود را وارد کنید، بدون '/pathname'. پس از ایجاد می‌توانید قوانین احراز هویت مسیر را سفارشی کنید.\n\nتوجه: خود URL مبدأ نیازی به احراز هویت ندارد؛ محافظت فقط برای دسترسی از طریق دامنه برنامه تعیین‌شده اعمال می‌شود.",
        domain_field_label: 'دامنه برنامه',
        domain_field_placeholder: 'your-domain',
        domain_field_description: 'این URL به‌عنوان پروکسی محافظت احراز هویت برای URL اصلی عمل می‌کند. دامنه سفارشی پس از ایجاد قابل اعمال است.',
        domain_field_description_short: 'این URL به‌عنوان پروکسی محافظت احراز هویت برای URL اصلی عمل می‌کند.',
        domain_field_tooltip: "برنامه‌های محافظت‌شده توسط Logto به‌صورت پیش‌فرض در 'your-domain.{{domain}}' میزبانی می‌شوند. دامنه سفارشی پس از ایجاد قابل اعمال است.",
        create_application: 'ایجاد برنامه',
        create_protected_app: 'ایجاد سریع',
        errors: {
            domain_required: 'دامنه شما الزامی است.',
            domain_in_use: 'این نام زیردامنه از قبل در حال استفاده است.',
            invalid_domain_format: "قالب زیردامنه نامعتبر: فقط از حروف کوچک، اعداد و خط تیره '-' استفاده کنید.",
            url_required: 'URL مبدأ الزامی است.',
            invalid_url: "قالب URL مبدأ نامعتبر: از http:// یا https:// استفاده کنید. توجه: '/pathname' فعلاً پشتیبانی نمی‌شود.",
            localhost: 'لطفاً ابتدا سرور محلی خود را به اینترنت متصل کنید. درباره <a>توسعه محلی</a> بیشتر بدانید.',
        },
    },
    id_token_claims: {
        card_title: 'ادعاهای توکن شناسایی',
        card_description: 'scopeهای کاربر اضافی را هنگام ورود برنامه محافظت‌شده درخواست کنید تا ادعاهای توسعه‌یافته فعال در توکن شناسایی ارسالی گنجانده شوند.',
        field_title: 'scopeهای اضافی',
        field_description: 'ادعاها فقط وقتی گنجانده می‌شوند که در <a>JWT سفارشی > توکن شناسایی</a> فعال شده باشند و scope متناظر در اینجا درخواست شود.',
        table_column_scope: 'Scope',
        table_column_claims_forwarded: 'ادعاهای ارسالی',
        disabled_claims_hint: 'ادعاهای خاکستری هنوز ارسال نمی‌شوند. آن‌ها را در <a>JWT سفارشی > توکن شناسایی</a> فعال کنید تا در توکن شناسایی گنجانده شوند.',
    },
    success_message: '🎉 احراز هویت برنامه با موفقیت فعال شد! تجربه جدید وب‌سایت خود را کشف کنید.',
};
export default Object.freeze(protected_app);
